export const SET_CATEGORIES = "SET_CATEGORIES";
export const RESET_CATEGORIES = "RESET_CATEGORIES";
export const SET_SPECIFIC_CATEGORIES = "SET_SPECIFIC_CATEGORIES";
export const RESET_SPECIFIC_CATEGORIES = "RESET_SPECIFIC_CATEGORIES";
export const SET_SUB_CATEGORIES = "SET_SUB_CATEGORIES";
export const RESET_SUB_CATEGORIES = "RESET_SUB_CATEGORIES";
export const SET_SPECIFIC_SUB_CATEGORIES = "SET_SPECIFIC_SUB_CATEGORIES";
export const RESET_SPECIFIC_SUB_CATEGORIES = "RESET_SPECIFIC_SUB_CATEGORIES";
